import { apiClient } from "./client";
import { updateFlagStatus } from "./audit";
import type { FlagStatus } from "@/types";
import type { Discrepancy, DismissReason, Page, PushTaskRequest, PushTaskResponse } from "@/types/ezyvet";

const BASE = "/api/v1/discrepancies";

export async function listDiscrepancies(params: { status?: FlagStatus; limit?: number; offset?: number } = {}): Promise<Page<Discrepancy>> {
  const { data } = await apiClient.get<Page<Discrepancy>>(BASE, { params: { limit: 100, offset: 0, ...params } });
  return data;
}

export async function getDiscrepancy(id: string): Promise<Discrepancy> {
  const { data } = await apiClient.get<Discrepancy>(`${BASE}/${id}`);
  return data;
}

/** Creates an ezyVet task (POST /v2/task) for the flagged item. */
export async function pushTask(id: string, req: PushTaskRequest): Promise<PushTaskResponse> {
  const { data } = await apiClient.post<PushTaskResponse>(`${BASE}/${id}/push-task`, req);
  return data;
}

export const DISMISS_REASONS: Record<DismissReason, string> = {
  intended_discount: "Intended discount / no charge",
  false_positive: "False positive (not performed)",
  billed_elsewhere: "Billed on another invoice",
  bundled_service: "Included in a bundled service",
  other: "Other",
};

/** Dismissal goes through the flag endpoint, which stores the reason code and notes. */
export async function dismissDiscrepancy(id: string, reason: DismissReason, note: string): Promise<void> {
  await updateFlagStatus(id, "dismissed", { reason, notes: note.trim() || undefined });
}
